import React from 'react'
import Liepin from './Liepin.png';

const LiePinIcon = () => {
  return (
    <div className='svg-icon'>
      <img width="25.25" height="25.25" viewBox="0 0 25.25 25.25" src={Liepin} alt="" />
    </div>
  )
}

export default LiePinIcon
